const config = {
    loja_id: 3
};

export default config;